import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroBannerSimple = _resolveComponent("HeroBannerSimple")!

  return (_openBlock(), _createBlock(_component_HeroBannerSimple, {
    title: _ctx.title,
    scrim: _ctx.content.isScrimEnabled,
    image: _ctx.image
  }, null, 8, ["title", "scrim", "image"]))
}